<fieldset class="sps-fieldset form-data-container separator">
  <div class="grid w-full">
    @switch (paymentData.paymentMethod) {
      @case (PaymentMethodName.PAYPAL) {
        <div class="col-12 flex flex-column gap-2">
          <div class="flex flex-column gap-2 w-full">
            <label for="paypal-email">{{ i18n.i18nLng()['PAYPALEMAIL'] }}
              @if (paymentData?.active) {
                <sup class="sps-sup">*</sup>
              }
            </label>
            <input pInputText
                   id="paypal-email"
                   maxlength="255"
                   [(ngModel)]="paymentData.payPalEmailAddress"
                   [required]="paymentData?.active"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="paymentInvalidFlags?.payPalEmailAddress ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="paymentInvalidFlags?.payPalEmailAddress"
                   [attr.aria-describedby]="paymentInvalidFlags?.payPalEmailAddress ? 'email-invalid-help' : null"
                   pSize="large"/>
            @if (paymentInvalidFlags?.payPalEmailAddress) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            } @else {
              @if (paymentInvalidFlags.invalidEmailFormat) {
                <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILINFO'] }}</small>
              }
            }
          </div>
        </div>
      }
      @default {
        <div class="col-12 flex flex-column gap-2">
          <div class="flex flex-column gap-2 w-full">
            <label for="account-holder">
              {{ i18n.i18nLng()['ACCOUNTHOLDER'] }}
              <sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="account-holder"
                   maxlength="70"
                   [(ngModel)]="paymentData.accountHolder"
                   [required]="true"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="paymentInvalidFlags?.accountHolder ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="paymentInvalidFlags?.accountHolder"
                   [attr.aria-describedby]="paymentInvalidFlags?.accountHolder ? 'accountholder-invalid-help' : null"
                   pSize="large" />
            @if (paymentInvalidFlags?.accountHolder) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="accountholder-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-12 flex flex-column gap-2">
          <div class="flex flex-column gap-2 w-full">
            <label for="IBAN">
              IBAN
              <sup class="sps-sup">*</sup>
            </label>
            <p-inputmask
                [styleClass]="paymentData.IBAN && paymentData.IBAN.length > 0 ? 'w-full uppercase' : 'w-full'"
                inputId="IBAN"
                ariaLabel="IBAN"
                [(ngModel)]="paymentData.IBAN"
                [autoClear]="false"
                mask="DE99 9999 9999 9999 9999 99"
                slotChar=""
                [required]="true"
                [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                [attr.aria-invalid]="showInvalidIBAN"
                [ngClass]="paymentInvalidFlags?.IBAN ? 'ng-invalid ng-dirty' : null"
                (onComplete)="checkIBAN()"
                size="large"/>
            @if (showInvalidIBAN || paymentInvalidFlags.IBAN) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="IBAN-invalid-help">{{ i18n.i18nLng()['INVALIDIBANHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-12 flex flex-column gap-2">
          <div class="flex flex-column gap-2 w-full">
            <label for="BIC">
              BIC
              <sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="BIC"
                   maxlength="11"
                   [(ngModel)]="paymentData.BIC"
                   [required]="true"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="paymentInvalidFlags?.BIC ? 'ng-invalid ng-dirty' : (paymentData.BIC && paymentData.BIC.length > 0) ? 'uppercase' : null"
                   [attr.aria-invalid]="paymentInvalidFlags?.BIC"
                   [attr.aria-describedby]="paymentInvalidFlags?.BIC ? 'bic-invalid-help' : null"
                   pSize="large" />
            @if (paymentInvalidFlags?.BIC) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="bic-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-12 flex flex-column gap-2">
          <div class="flex flex-column gap-2 w-full">
            <label for="bank">
              {{ i18n.i18nLng()['BANK'] }}
              <sup class="sps-sup">*</sup>
            </label>
            <input pInputText
                   id="bank"
                   maxlength="70"
                   [(ngModel)]="paymentData.bank"
                   [required]="true"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="paymentInvalidFlags?.bank ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="paymentInvalidFlags?.bank"
                   [attr.aria-describedby]="paymentInvalidFlags?.bank ? 'bank-invalid-help' : null"
                   pSize="large" />
          </div>
        </div>
      }
    }
  </div>
</fieldset>
